import dayjs from "dayjs";
import { apiFetch } from './interceptor';
const BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:3000/v1";

const payApi = {
    // pay post api to hitpay
    pay: async (token, paymentData) => {
        const response = await apiFetch(`${BASE_URL}/pay`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(paymentData),
        });
        const data = await response.json();
        return { 
            status: response.status, 
            data
        };
    },

    payMaya: async (token, paymentData) => {
        const response = await apiFetch(`${BASE_URL}/pay/maya`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,   
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(paymentData),
        });
        const data = await response.json();
        return { 
            status: response.status, 
            data
        };
    },

    payPhmpay: async (token, paymentData) => {
        const response = await apiFetch(`${BASE_URL}/pay/ph/create-order`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,   
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(paymentData),
        });
        const data = await response.json();
        return { 
            status: response.status, 
            data
        };
    },
    
    // Check payment status using webhook-confirm endpoint (for non-Maya payments)
    checkPaymentStatus: async (token, paymentId, paymentRequestId) => {
        const response = await apiFetch(`${BASE_URL}/pay/webhook-confirm`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                paymentId,
                paymentRequestId
            }),
        });
        const data = await response.json();
        return { 
            status: response.status, 
            data
        };
    },

    // Check Maya payment status using the new endpoint
    checkMayaPaymentStatus: async (token, paymentId) => {
        const response = await apiFetch(`${BASE_URL}/pay/maya/check/${paymentId}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });
        const data = await response.json();
        return { 
            status: response.status, 
            data
        };
    },

    // Check Philippines wallet payment status
    checkPhmpayPaymentStatus: async (token, merchantOrderId) => {
        const response = await apiFetch(`${BASE_URL}/pay/ph/check/${merchantOrderId}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });
        const data = await response.json();
        return { 
            status: response.status, 
            data
        };
    },

    // Fetch payment transactions
    getPaymentTransactions: async (token, page = 1, limit = 100) => {
        const response = await apiFetch(`${BASE_URL}/pay/payment-transactions?page=${page}&limit=${limit}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return {
            status: response.status,
            data,
        };
    },

    // Fetch a single payment request by payment_request_id
    getPaymentRequest: async (token, paymentRequestId) => {
        const response = await apiFetch(`${BASE_URL}/pay/hitpay-payment-request`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ payment_request_id: paymentRequestId }),
        });
        const data = await response.json();
        return {
            status: response.status,
            data,
        };
    },
};

export default payApi;

